// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__Y8xlW","checkmark":"Checkbox_checkmark__FcRoM"};